import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, isRef as _isRef } from "vue"

const _hoisted_1 = { style: {"color":"red","font-size":"12px","margin-left":"5px"} }
const _hoisted_2 = { class: "dialog-footer" }

import {
  computed,
  ref,
  PropType,
  Ref,
  watch,
  nextTick,
  reactive,
} from 'vue'
import { ElDialog } from 'element-plus'
import { useI18n } from 'vue-i18n'
import { upsertOperator } from '@/api/operation'
import { ElInput } from 'element-plus'
import { ElMessage, ElMessageBox } from 'element-plus'
import useProtocolEnums from '@/hooks/useProtocolEnums'
import useFormRules from '@/hooks/useFormRules'
import FormRulesFactory from '@/common/formRules'
import { FieldEnable } from '@/types/types'
export type OperationType = 'create' | 'edit'


import { defineComponent } from 'vue'

const __default__ = defineComponent({
  name: 'OperatorUpsert',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  modelValue: {
    type: Boolean,
    required: true,
  },
  operationType: {
    type: String as PropType<OperationType>,
    required: true,
  },
  operatorInfo: {
    type: Object as PropType<Record<string, any>>,
  },
},
  emits: ["update:modelValue", "submitted"],
  setup(__props, { emit }: { emit: ({
  (e: 'update:modelValue', value: boolean): void
  (e: 'submitted'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props

const { country, currency } = useProtocolEnums()
const { t } = useI18n()





const createRawFormData = () => ({})

const formCom = ref()
const formData: Ref<Record<string, any>> = ref(createRawFormData())
// const { createLetterStartRule } = useFormRules()
// const rules = {
//   name: [...createLetterStartRule()],
// }
const validatePhone = (rule: any, value: any, callback: any) => {
  const phoneReg = /^1[3456789]\d{9}$/
  if (!value) {
    return callback(new Error('Phone number cannot be empty'))
  } else if (!phoneReg.test(value)) {
    return callback(new Error('Please enter a valid phone number'))
  } else {
    callback()
  }
}
const validateEmail = (rule: any, value: any, callback: any) => {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
  if (!value) {
    return callback(new Error('Email  cannot be empty'))
  } else if (!emailRegex.test(value)) {
    return callback(new Error('Please enter a valid email'))
  } else {
    callback()
  }
}
const operatorFormRule = ref({
  ...FormRulesFactory.generateCustomRules(['country', 'currency'], 'selectNone', 'selectNone'),
  ...FormRulesFactory.generateCustomRules(
    ['operatorPrincipal', 'name', 'company', 'address', 'ftn'],
    'inputEmpty',
    'inputInvalid',
  ),
  ...FormRulesFactory.generateCustomRules(['principalPhone'], 'inputEmpty', 'inputInvalid', {
    // pattern: /^1[3-9]\d{9}$/,
    pattern: /^[+]?(\d{1,4}[-()])?\(?\d{1,4}\)?[-]?\d{1,4}[-]?\d{1,4}[-]?\d{1,4}$/,
    min: 4,
    max: 15,
  }),
  ...FormRulesFactory.generateCustomRules(['principalEmail'], 'inputEmpty', 'inputInvalid', {
    pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  }),
})
const rules = reactive({
  name: [{ required: true, message: 'Name cannot be empty', trigger: 'blur' }],
  country: [{ required: true, message: 'Please select your country', trigger: 'blur' }],
  currency: [{ required: true, message: 'Please select currency', trigger: 'blur' }],
  operatorPrincipal: [
    { required: true, message: 'operatorPrincipal cannot be empty', trigger: 'blur' },
  ],

  principalPhone: [{ validator: validatePhone, trigger: 'blur' }],
  principalEmail: [{ validator: validateEmail, trigger: 'blur' }],
})

const isSubmitting = ref(false)
const showDialog = computed({
  get: () => props.modelValue,
  set: (val: boolean) => {
    emit('update:modelValue', val)
  },
})

const dialogTitle = computed(
  () =>
    ({
      create: `${t('Base.add')}`,
      edit: `${t('Base.edit')}`,
    }[props.operationType]),
)

watch(showDialog, async (val) => {
  if (val) {
    if (props.operationType !== 'create') {
      formData.value = { ...props.operatorInfo }
      formData.value.isAgentOperating = !formData.value.isSelfOperating
    } else {
      await nextTick()
      formCom.value.clearValidate()
    }
  } else {
    formData.value = createRawFormData()
  }
})

const submit = async () => {
  try {
    await formCom.value.validate()
    isSubmitting.value = true

    formData.value.selfOperating = FieldEnable.CES_ENABLE
    if (formData.value.isAgentOperating) {
      formData.value.selfOperating = FieldEnable.CES_DISABLE
    }

    await upsertOperator(formData.value)
    if (props.operationType === 'edit') {
      ElMessage.success(t(`Base.updateSuccess`))
    } else {
      ElMessage.success(t(`Base.createSuccess`))
    }
    emit('submitted')
    showDialog.value = false
  } catch (error) {
    //
  } finally {
    isSubmitting.value = false
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createBlock(_unref(ElDialog), {
    modelValue: _unref(showDialog),
    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_isRef(showDialog) ? (showDialog).value = $event : null)),
    width: "50%",
    class: "upsert-dialog",
    title: _unref(dialogTitle),
    "z-index": 2000
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_2, [
        _createVNode(_component_el_button, {
          onClick: _cache[10] || (_cache[10] = ($event: any) => (showDialog.value = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('Base.cancel')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: submit,
          disabled: !_ctx.$hasPermission('post'),
          loading: isSubmitting.value
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('Base.confirm')), 1)
          ]),
          _: 1
        }, 8, ["disabled", "loading"])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        ref_key: "formCom",
        ref: formCom,
        "label-position": "top",
        "require-asterisk-position": "right",
        model: formData.value,
        rules: operatorFormRule.value
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_row, { gutter: 24 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('Base.name'),
                    prop: "name",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ElInput), {
                        modelValue: formData.value.name,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.name) = $event)),
                        minlength: 4
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('Operation.agencyOperation')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_switch, {
                        modelValue: formData.value.isAgentOperating,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.isAgentOperating) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('Operation.company'),
                    prop: "company",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ElInput), {
                        modelValue: formData.value.company,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.company) = $event)),
                        minlength: 4
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('Operation.country'),
                    prop: "country",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: formData.value.country,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.country) = $event)),
                        clearable: ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(country), (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              label: item.label,
                              value: item.value,
                              key: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('Operation.companyAddress'),
                    prop: "address",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ElInput), {
                        modelValue: formData.value.address,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.address) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('Operation.tfn'),
                    prop: "tfn",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ElInput), {
                        modelValue: formData.value.tfn,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.tfn) = $event)),
                        minlength: 20,
                        maxlength: 20
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('Operation.currency'),
                    prop: "currency",
                    required: ""
                  }, {
                    label: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(_unref(t)('Operation.currency')), 1),
                      _createElementVNode("span", _hoisted_1, "(" + _toDisplayString(_unref(t)('Operation.currencyNotChange')) + ")", 1)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: formData.value.currency,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.currency) = $event)),
                        disabled: props.operationType == 'edit' ? true : false,
                        clearable: ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(currency), (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              label: item.label,
                              value: item.value,
                              key: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "disabled"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('Operation.contacts'),
                    prop: "operatorPrincipal",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ElInput), {
                        modelValue: formData.value.operatorPrincipal,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.value.operatorPrincipal) = $event)),
                        minlength: 4
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('Operation.phone'),
                    prop: "principalPhone",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ElInput), {
                        modelValue: formData.value.principalPhone,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formData.value.principalPhone) = $event)),
                        minlength: 5
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('Operation.email'),
                    prop: "principalEmail",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ElInput), {
                        modelValue: formData.value.principalEmail,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formData.value.principalEmail) = $event)),
                        minlength: 5
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})